import Layout from 'layout'
import { ReactElement } from 'react'
import { withServerSideProps } from 'shared/withPageProps'
import { IntroCardData, IntroContentData } from 'utils/content'
import { styled } from '@mui/system'

import { Hero, Features, About, Dashboard, FreeTrial } from '@/components/simplified'

const PrimarySpan = styled('span')(({ theme }) => ({
	color: theme.palette.primary.main
}))

export const getServerSideProps = withServerSideProps(async () => {
	return {
		props: {}
	}
})

export default function HomePage() {
	return (
		<>
			<Hero
				title={
					<>
						Automate Your Tests. <br />
						Cover Your Apps.
					</>
				}
				description={
					<>
						ASTA instantly performs fully autonomous <PrimarySpan>smoke, accessibility, and performance testing</PrimarySpan> of
						every build so you can deploy with confidence.
						<br />
						<br />
						Get early access to ASTA.
						<br />
						If it's a fit, we'll offer you:
						<br />
						<br />
						⭐️ Free Plus subscription for life
						<br />
						⭐️ Concierge setup and support services
						<br />
						⭐️ Free product tuning for your app
					</>
				}
				buttons={[
					{
						text: 'Get a demo',
						href: 'https://outlook.office365.com/owa/calendar/ASTADemoScheduling@bpsconsulting.com/bookings/',
						style: 'outlined',
						openInNewTab: true
					},
					{
						text: 'Get early access',
						href: 'https://forms.office.com/r/rm048fwmxS',
						style: 'primary',
						openInNewTab: true
					}
				]}
				backgroundImage="assets/images/landing/bg-mockup-default.png"
				layout="text-with-image"
			/>

			<Features
				title={
					<>
						Introducing ASTA:
						<br />
						The Autonomous Software Testing Agent
					</>
				}
				description={IntroContentData.content}
				columns={3}
				backgroundColor="default"
				features={IntroCardData.map(card => ({
					title: card.title,
					listItems: card.content,
					icon: card.icon
				}))}
			/>

			<About
				title="So Smart It's Simple"
				content={`From the Start page, enter the base URL of your application and click "Start". That's it! ASTA explores your application, testing as it goes. The agent logs all tests and results for reporting and problem analysis. The agent also builds a model of the application and uses it to optimize testing and report test coverage.`}
				image="assets/images/landing/asta-start-page.png"
				imageCaption="ASTA start page interface"
				layout="text-above-image"
				backgroundColor="default"
				textAlign="center"
			/>

			<Dashboard
				title="Actionable Results"
				content="The dashboard report provides a graphical summary of test results. You can drill down to see details for reported errors."
				image="assets/images/landing/asta-dashboard.png"
				imageAlt="ASTA Dashboard"
			/>

			<FreeTrial />
		</>
	)
}

HomePage.getLayout = function getLayout(page: ReactElement) {
	return (
		<Layout title="Home" isLoggedIn={page.props.isLoggedIn} user={page.props.user}>
			{page}
		</Layout>
	)
}
